import { SxProps, Theme } from "@mui/material";

export const timeItemBoxStyles = (
  index: number,
  total: number,
  theme: Theme,
): SxProps<Theme> => ({
  display: "flex",
  justifyContent: "space-between",
  paddingBottom: index < total - 1 ? 1 : 0,
  borderBottom:
    index < total - 1
      ? `1px solid ${theme.palette.modalColors.separatorColor}`
      : "none",
  marginBottom: index < total - 1 ? 1 : 0,
});

export const itemTextStyles: SxProps<Theme> = (theme) => ({
  color: theme.palette.modalColors.colorLable,
  fontWeight: 600,
  fontSize: "14px",
});

export const itemTimeStyles: SxProps<Theme> = {
  color: "#06B6D4",
  fontSize: "16px",
  fontWeight: 600,
};
